// extracted by mini-css-extract-plugin
export var galleryColumn = "gallery-module--galleryColumn--ldjj9";
export var galleryContainer = "gallery-module--galleryContainer--3H+Kr";